import React from "react";
import { Helmet } from "react-helmet";
import ResourcesCommonComponent from "./ResourcesCommonComponent";
import { resourcesServices } from "../../services/resourcesService";
import { defer } from "react-router-dom";

const HospitalForCancer = () => {
  return (
    <div>
      <Helmet>
        <title>
          Government And Private Cancer Hospitals Near You - Cope With Cancer
        </title>

        <meta
          name="description"
          content="Cancer is one of the leading causes of death. Early detection of this disease is important. We have listed some govt. and private cancer hospitals near you."
        />
        <meta name="robots" content="index,nofollow" />
        <link
          rel="canonical"
          href="https://www.copewithcancer.org/cancer-hospitals"
        />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="Government And Private Cancer Hospitals Near You - Cope With Cancer"
        />
        <meta
          property="og:description"
          content="Cancer is one of the leading causes of death. Early detection of this disease is important. We have listed some govt. and private cancer hospitals near you."
        />
        <meta
          property="og:url"
          content="https://www.copewithcancer.org/cancer-hospitals"
        />
        <meta property="og:site_name" content="Cope with Cancer" />
        <meta
          property="article:publisher"
          content="https://www.facebook.com/copewithcancer/"
        />
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:description"
          content="Cancer is one of the leading causes of death. Early detection of this disease is important. We have listed some govt. and private cancer hospitals near you."
        />
        <meta
          name="twitter:title"
          content="Government And Private Cancer Hospitals Near You - Cope With Cancer"
        />
        <meta name="twitter:site" content="@copewithcancer" />
        <meta name="twitter:creator" content="@copewithcancer" />
        <meta property="DC.date.issued" content="2016-06-06T10:41:53+00:00" />
      </Helmet>

      <div className="topspace">
        <div className="text-center">
          <div className="cancerhospitals"><div className="bannertitleNew mediabannertitleNew">Cancer Hospitals</div></div>
          {/* <img src={CancerHospitals} alt="" className="w-100"></img> */}
          <h1 className="bannertitle displayNone">Cancer Hospitals</h1>
        </div>
        <div className="contentBox">
          <div className="container">
            <h3 className="Bold28">Cancer Hospitals</h3>
            <p className="Bold14 mb20">
              Government & Private Cancer Hospitals in India
            </p>
            <ResourcesCommonComponent senderComponent="Accomodation" />
          </div>
        </div>
      </div>

      {/* <div className="container"><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
                <br /><br />
                <h1>Cancer Hospitals</h1>
                <p><strong>Government &amp; Private Cancer Hospitals in India</strong></p>

            </div> */}
    </div>
  );
};
export default HospitalForCancer;

const getResource = async ({ request, params }) => {
  try {
    const url = new URL(request.url);
    const searchParams = url.search ? url.search : "?pageNumber=1&city=mumbai&state=maharashtra&location";
    console.log(searchParams);
    const resource = "hospitalsForCancerCare";
    const responce = await new Promise((resolve, reject) => {
      resourcesServices.getResources(
        resource,
        searchParams,
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
    return {
      resources: responce.data.ResponseObject,
      totalRecords: responce.data.TotalRecords,
    };
  } catch (err) {
    console.log(err);
    return null;
  }
};

const getLocation = async ({ request, params }) => {
  try {
    const url = new URL(request.url);
    const searchParams = url.search ? url.search : null;
    console.log(searchParams);
    const resource = "hospitalsForCancerCare";
    const responce = await new Promise((resolve, reject) => {
      resourcesServices.getLocations(
        resource,
        searchParams,
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
    return responce.data.ResponseObject;
  } catch (err) {
    console.log(err);
    return null;
  }
};
export const loader = async ({ request, params }) => {
  return defer({
    data: await getResource({ request, params }),
    locations: await getLocation({ request, params }),
  });
};
